import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const getEmailNotifyFrequency = (username: string): Promise<string> =>
  fetchFromOldApi(
    `/json/user/${encodeURIComponent(username)}/emailnotifyfreq`,
  ).then((r) => r.json());

export const putEmailNotifyFrequency = (
  username: string,
  value: string,
): Promise<string> =>
  fetchFromOldApi(
    `/json/user/${encodeURIComponent(username)}/emailnotifyfreq`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(value),
    },
  ).then((r) => r.json());

type PropsType = {
  userName?: string;
};

export const useGetEmailNotificationFrequency = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
  disabled?: boolean,
): UseSWROutput<string> => {
  const { userName } = props;

  return useSWR(
    !disabled && !!userName ? ['getEmailNotifyFrequency', userName] : null,
    ([_key, userName]) => getEmailNotifyFrequency(userName),
    swrConfig,
  );
};
